import { Component, computed, OnDestroy, OnInit, Signal } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from '../shared/local-storage.service';
import { GroundfishDelivery } from '../shared/groundfish-delivery.model';
import { HMSDelivery } from '../shared/hms-delivery.model';
import { TrawlDelivery } from '../shared/trawl-delivery.model';

/**
 * List of completed deliveries.
 * Small component to display the deliveries and navigate to them.
 */
@Component({
    selector: 'app-delivery-list',
    templateUrl: './delivery-list.component.html',
    styleUrls: ['./delivery-list.component.css'],
    standalone: false
})
export class DeliveryListComponent {


  landings: Signal<(GroundfishDelivery | HMSDelivery | TrawlDelivery)[]>;
  editedLogbookId: Signal<string>;


  constructor(public dataSync: LocalStorageService, public router: Router) { 
    this.editedLogbookId = this.dataSync.current_user().trawlFishery ? computed(() => dataSync.edited_trawlLogbook().logbookId) :
    computed(() => dataSync.edited_logbook().GF.logbookId ?? dataSync.edited_logbook().HMS.logbookId);

    this.landings = computed(() => this.dataSync.current_user().trawlFishery ? dataSync.received_trawlLogbooks() : dataSync.received_logbooks());
  }


  /**
   * Departure date for the delivery, where the fishery tracks one.
   * HMS and Trawl store a departureDate; Groundfish deliveries have no departure date.
   */
  getDepartureDate(landing: GroundfishDelivery | HMSDelivery | TrawlDelivery): Date | undefined {
    if (landing instanceof HMSDelivery || landing instanceof TrawlDelivery) return landing.departureDate;
    return undefined;
  }

  /**
   * Return date for the delivery. HMS calls this the arrival date;
   * Groundfish and Trawl store it as returnDate.
   */
  getReturnDate(landing: GroundfishDelivery | HMSDelivery | TrawlDelivery): Date | undefined {
    if (landing instanceof HMSDelivery) return landing.arrivalDate;
    return landing.returnDate;
  }

  /**
   * Date format for departure/return dates. Only Trawl captures a meaningful time,
   * so HMS and Groundfish are shown date-only.
   */
  getDepReturnDateFormat(landing: GroundfishDelivery | HMSDelivery | TrawlDelivery): string {
    return landing instanceof TrawlDelivery ? 'HH:mm, EE, MMM.dd' : 'EE, MMM.dd';
  }


  onLandingClick(index: number) {
    this.router.navigate([this.landings()[index] instanceof GroundfishDelivery ? 'delivery_detail' :
      this.landings()[index] instanceof TrawlDelivery ? 'trawl_delivery' :
        'hms_delivery_detail', this.landings()[index].logbookId == this.editedLogbookId() ? 2 : 1, index], { queryParams: { previous: 'deliveries_list' } });
    if ((document.documentElement.scrollTop || document.body.scrollTop) > 0) window.scrollTo(0, 0);
  }

}
